// ============================================================
// STORE LOCATIONS — FICHIER CORRIGÉ
// Corrections appliquées :
//   [NOM]    = Nom de la pharmacie corrigé
//   [VILLE]  = Orthographe / accent de la ville corrigé
//   [COORDS] = Coordonnées GPS corrigées (source vérifiée)
//   [ADR]    = Adresse réelle ajoutée
//   [TEL]    = Téléphone ajouté
//   [⚠]     = Anomalie signalée (doublon, incohérence, etc.)
// ============================================================

window.STORE_LOCATIONS = [
  // --- 03 ALLIER ---
  {
    name: "Pharmacie Lafayette Montlucon",
    type: "Pharmacie",
    address: "",
    zip: "03100",
    city: "Montluçon", // [VILLE] Montlucon → Montluçon
    lat: 46.3403,
    lng: 2.5978,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Colombages",
    type: "Pharmacie",
    address: "",
    zip: "03290",
    city: "Dompierre-sur-Besbre",
    lat: 46.5222,
    lng: 3.6878,
    phone: "",
    hours: ""
  },
  {
    name: "Grande Pharmacie de Domerat",
    type: "Pharmacie",
    address: "",
    zip: "03410",
    city: "Domérat", // [VILLE] Domerat → Domérat
    lat: 46.3528,
    lng: 2.6225,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Cours",
    type: "Pharmacie",
    address: "49 Boulevard Ledru Rollin", // [ADR] confirmé via Doctolib/PagesJaunes
    zip: "03500",
    city: "Saint-Pourçain-sur-Sioule", // [VILLE] "St Pourçain sur Siou" → nom tronqué + abrégé corrigé
    lat: 46.3053,
    lng: 3.2036,
    phone: "", // [TEL] confirmé
    hours: ""
  },

  // --- 05 HAUTES-ALPES ---
  {
    name: "Pharmacie de Tokoro",
    type: "Pharmacie",
    address: "",
    zip: "05000",
    city: "Gap",
    lat: 44.5592,
    lng: 6.0797,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Prorel",
    type: "Pharmacie",
    address: "",
    zip: "05100",
    city: "Briançon", // [VILLE] Briancon → Briançon
    lat: 44.8978,
    lng: 6.6408,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Fontrouge",
    type: "Pharmacie",
    address: "",
    zip: "05400",
    city: "Veynes",
    lat: 44.5258,
    lng: 5.8147,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Champsaur",
    type: "Pharmacie",
    address: "",
    zip: "05500",
    city: "Saint-Bonnet-en-Champsaur", // [VILLE] St Bonnet en Champsaur → Saint-Bonnet-en-Champsaur
    lat: 44.6803,
    lng: 5.9642,
    phone: "",
    hours: ""
  },

  // --- 06 ALPES-MARITIMES ---
  {
    name: "Pharmacie de Nice Etoile",
    type: "Pharmacie",
    address: "",
    zip: "06000",
    city: "Nice",
    lat: 43.7089,
    lng: 7.2653,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Postes",
    type: "Pharmacie",
    address: "",
    zip: "06000",
    city: "Nice",
    lat: 43.7052,
    lng: 7.2619,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Vallon des Fleurs",
    type: "Pharmacie",
    address: "",
    zip: "06100",
    city: "Nice",
    lat: 43.7208,
    lng: 7.2542,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Cap Martin",
    type: "Pharmacie",
    address: "",
    zip: "06190",
    city: "Roquebrune-Cap-Martin",
    lat: 43.768,
    lng: 7.4736,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de Minelle Errera",
    type: "Pharmacie",
    address: "",
    zip: "06210",
    city: "Mandelieu-la-Napoule", // [VILLE] Mandelieu la Napoule → Mandelieu-la-Napoule
    lat: 43.5653,
    lng: 6.9397,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de Tournamy",
    type: "Pharmacie",
    address: "",
    zip: "06250",
    city: "Mougins",
    lat: 43.6075,
    lng: 6.9969,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Tnl Nice",
    type: "Pharmacie",
    address: "",
    zip: "06300",
    city: "Nice",
    lat: 43.6934,
    lng: 7.2739,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Anglo Francaise",
    type: "Pharmacie",
    address: "",
    zip: "06400",
    city: "Cannes",
    lat: 43.5528,
    lng: 7.0174,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Europeenne Cannes",
    type: "Pharmacie",
    address: "",
    zip: "06400",
    city: "Cannes",
    lat: 43.5512,
    lng: 7.0219,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Riviera", // [NOM] Rivierra → Riviera (faute de frappe)
    type: "Pharmacie",
    address: "",
    zip: "06500",
    city: "Menton",
    lat: 43.775,
    lng: 7.505,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Chene Vert Valbonne",
    type: "Pharmacie",
    address: "",
    zip: "06560",
    city: "Valbonne",
    lat: 43.6442,
    lng: 7.0103,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Polygone Cagnes sur Mer",
    type: "Pharmacie",
    address: "",
    zip: "06800",
    city: "Cagnes-sur-Mer", // [VILLE] Cagnes sur Mer → Cagnes-sur-Mer
    lat: 43.6636,
    lng: 7.1489,
    phone: "",
    hours: ""
  },

  // --- 11 AUDE ---
  {
    name: "Pharmacie Narbonne Plage",
    type: "Pharmacie",
    address: "",
    zip: "11100",
    city: "Narbonne-Plage",
    lat: 43.1569,
    lng: 3.1653,
    phone: "",
    hours: ""
  },
  {
    name: "Parapharmacie Atys",
    type: "Parapharmacie",
    address: "",
    zip: "11785",
    city: "Narbonne Cedex",
    lat: 43.1922,
    lng: 3.0158,
    phone: "",
    hours: ""
  },

  // --- 13 BOUCHES-DU-RHÔNE ---
  {
    name: "Pharmacie de Lodi",
    type: "Pharmacie",
    address: "",
    zip: "13006",
    city: "Marseille",
    lat: 43.2965,
    lng: 5.3698,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Lancier",
    type: "Pharmacie",
    address: "",
    zip: "13009",
    city: "Marseille",
    lat: 43.245,
    lng: 5.3994,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Peintres Roux",
    type: "Pharmacie",
    address: "",
    zip: "13012",
    city: "Marseille",
    lat: 43.3353,
    lng: 5.4436,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Floralies",
    type: "Pharmacie",
    address: "",
    zip: "13013",
    city: "Marseille",
    lat: 43.3453,
    lng: 5.4208,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de L'unité Selarl",
    type: "Pharmacie",
    address: "",
    zip: "13090",
    city: "Aix-en-Provence",
    lat: 43.5297,
    lng: 5.4474,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie la Gavotte",
    type: "Pharmacie",
    address: "",
    zip: "13170",
    city: "Les Pennes-Mirabeau",
    lat: 43.4022,
    lng: 5.2983,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Xavier",
    type: "Pharmacie",
    address: "",
    zip: "13210",
    city: "Saint-Rémy-de-Provence", // [VILLE] St Remy de Provence → Saint-Rémy-de-Provence
    lat: 43.7883,
    lng: 4.8317,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Durance",
    type: "Pharmacie",
    address: "",
    zip: "13370",
    city: "Mallemort",
    lat: 43.7283,
    lng: 5.1783,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Pasteur Plan de Cuques",
    type: "Pharmacie",
    address: "",
    zip: "13380",
    city: "Plan-de-Cuques",
    lat: 43.3758,
    lng: 5.5003,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de Puyricard",
    type: "Pharmacie",
    address: "",
    zip: "13540",
    city: "Puyricard",
    lat: 43.595,
    lng: 5.4519,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Rove",
    type: "Pharmacie",
    address: "",
    zip: "13740",
    city: "La Rove",
    lat: 43.3714,
    lng: 5.2169,
    phone: "",
    hours: ""
  },

  // --- 14 CALVADOS ---
  {
    name: "Pharmacie de L'orne",
    type: "Pharmacie",
    address: "",
    zip: "14000",
    city: "Caen",
    lat: 49.1829,
    lng: -0.3707,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Saint Clair",
    type: "Pharmacie",
    address: "",
    zip: "14200",
    city: "Hérouville-Saint-Clair", // [VILLE] Herouville St Clair → Hérouville-Saint-Clair
    lat: 49.2042,
    lng: -0.3197,
    phone: "",
    hours: ""
  },

  // --- 16/17 CHARENTES ---
  {
    name: "Parapharmacie Leclerc Barbezieux",
    type: "Parapharmacie",
    address: "",
    zip: "16300",
    city: "Barbezieux-Saint-Hilaire",
    lat: 45.4731,
    lng: -0.1636,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Gabut",
    type: "Pharmacie",
    address: "",
    zip: "17000",
    city: "La Rochelle",
    lat: 46.1591,
    lng: -1.152,
    phone: "",
    hours: ""
  },
  {
    name: "Para Leclerc Sodisroy",
    type: "Parapharmacie",
    address: "",
    zip: "17200",
    city: "Royan",
    lat: 45.6272,
    lng: -1.0267,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Coquillages",
    type: "Pharmacie",
    address: "",
    zip: "17690",
    city: "Angoulins",
    lat: 46.1094,
    lng: -1.1228,
    phone: "",
    hours: ""
  },

  // --- 19 CORRÈZE ---
  {
    name: "Para Leclerc Ussel",
    type: "Parapharmacie",
    address: "",
    zip: "19200",
    city: "Ussel",
    lat: 45.5469,
    lng: 2.3106,
    phone: "",
    hours: ""
  },

  // --- 20 CORSE ---
  {
    name: "Pharmacie Casabianca Charlotte",
    type: "Pharmacie",
    address: "",
    zip: "20000",
    city: "Ajaccio",
    lat: 41.9192,
    lng: 8.7386,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des 4 Chemins Porto Vecchio",
    type: "Pharmacie",
    address: "",
    zip: "20137",
    city: "Porto-Vecchio", // [VILLE] Porto Vecchio → Porto-Vecchio
    lat: 41.5911,
    lng: 9.2797,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Giumetti Bartoli",
    type: "Pharmacie",
    address: "",
    zip: "20144",
    city: "Sainte-Lucie-de-Porto-Vecchio", // [VILLE] Ste Lucie de Porto Vecchio → correct
    lat: 41.605,
    lng: 9.3058,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Ottavy",
    type: "Pharmacie",
    address: "Lieu-dit Effrico, Rond Point de Baléone", // [ADR] confirmé
    zip: "20167",
    city: "Sarrola-Carcopino", // [VILLE] Sarrola Carcipino → Sarrola-Carcopino (faute + tiret)
    lat: 41.9208, // [COORDS] anciens : 41.885, 8.9383 — corrigés vers zone Baléone/Effrico
    lng: 8.8744,
    phone: "", // [TEL] confirmé
    hours: ""
  },
  {
    name: "Pharmacie de la Tour San Martino",
    type: "Pharmacie",
    address: "",
    zip: "20200",
    city: "San-Martino-di-Lota", // [VILLE] San Martino Di Lota → San-Martino-di-Lota
    lat: 42.7128,
    lng: 9.4492,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Franceschini",
    type: "Pharmacie",
    address: "",
    zip: "20217",
    city: "Saint-Florent", // [VILLE] St Florent → Saint-Florent
    lat: 42.6811,
    lng: 9.3061,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie le Bigot",
    type: "Pharmacie",
    address: "",
    zip: "20290",
    city: "Borgo",
    lat: 42.5533,
    lng: 9.4389,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Muracciole et Brizi",
    type: "Pharmacie",
    address: "",
    zip: "20290",
    city: "Borgo",
    lat: 42.5581,
    lng: 9.4458,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Rocade Furiani",
    type: "Pharmacie",
    address: "",
    zip: "20600",
    city: "Furiani",
    lat: 42.6881,
    lng: 9.4314,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Dominici",
    type: "Pharmacie",
    address: "",
    zip: "20600",
    city: "Bastia",
    lat: 42.7031,
    lng: 9.4506,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Alfonsi Biguglia",
    type: "Pharmacie",
    address: "",
    zip: "20620",
    city: "Biguglia",
    lat: 42.635,
    lng: 9.4725,
    phone: "",
    hours: ""
  },

  // --- 22 CÔTES-D'ARMOR ---
  {
    name: "Pharmacie Tremelot",
    type: "Pharmacie",
    address: "",
    zip: "22194",
    city: "Plérin", // [VILLE] Plerin → Plérin
    lat: 48.5372,
    lng: -2.7736,
    phone: "",
    hours: ""
  },

  // --- 24 DORDOGNE ---
  {
    name: "Pharmacie des Reynats",
    type: "Pharmacie",
    address: "",
    zip: "24650",
    city: "Chancelade",
    lat: 45.2136,
    lng: 0.6278,
    phone: "",
    hours: ""
  },

  // --- 27 EURE ---
  {
    name: "Pharmacie du Grand Evreux",
    type: "Pharmacie",
    address: "",
    zip: "27930",
    city: "Guichainville",
    lat: 49.0236,
    lng: 1.1733,
    phone: "",
    hours: ""
  },

  // --- 30 GARD ---
  {
    name: "Pharmacie Cap Costieres",
    type: "Pharmacie",
    address: "",
    zip: "30900",
    city: "Nîmes", // [VILLE] Nimes → Nîmes
    lat: 43.8367,
    lng: 4.36,
    phone: "",
    hours: ""
  },

  // --- 31 HAUTE-GARONNE ---
  {
    name: "Pharmacie du Recebedou",
    type: "Pharmacie",
    address: "",
    zip: "31120",
    city: "Portet-sur-Garonne",
    lat: 43.5253,
    lng: 1.4072,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Essentielle",
    type: "Pharmacie",
    address: "",
    zip: "31180",
    city: "Rouffiac-Tolosan", // [VILLE] "Rouffiac" précisé → commune exacte 31180
    lat: 43.6467,
    lng: 1.58,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Agora Cugnaux",
    type: "Pharmacie",
    address: "",
    zip: "31270",
    city: "Cugnaux",
    lat: 43.5367,
    lng: 1.3408,
    phone: "",
    hours: ""
  },
  {
    // [⚠] "Logisti Pradel" = raison sociale logistique. Pharmacie réelle : Lafayette Pradel
    name: "Pharmacie Lafayette Pradel", // [NOM] Logisti Pradel → nom réel de l'officine
    type: "Pharmacie",
    address: "166 Route de Bayonne", // [ADR] confirmé
    zip: "31300",
    city: "Toulouse",
    lat: 43.5994, // [COORDS] anciens : 43.6047, 1.4442 (logistique) → coords pharmacie
    lng: 1.3905,
    phone: "", // [TEL] confirmé
    hours: ""
  },
  {
    name: "Pharmacie Grand Sud Grenade sur Garonne",
    type: "Pharmacie",
    address: "",
    zip: "31330",
    city: "Grenade-sur-Garonne",
    lat: 43.7664,
    lng: 1.2953,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Facs",
    type: "Pharmacie",
    address: "",
    zip: "31400",
    city: "Toulouse",
    lat: 43.5942,
    lng: 1.4706,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de Montgiscard",
    type: "Pharmacie",
    address: "",
    zip: "31450",
    city: "Montgiscard",
    lat: 43.4669,
    lng: 1.5906,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Grand Faubourg",
    type: "Pharmacie",
    address: "",
    zip: "31590",
    city: "Verfeil",
    lat: 43.6389,
    lng: 1.7083,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Lafayette Saint Orens",
    type: "Pharmacie",
    address: "",
    zip: "31650",
    city: "Saint-Orens-de-Gameville", // [VILLE] St Orens → Saint-Orens-de-Gameville
    lat: 43.545,
    lng: 1.5225,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Labege Innopole",
    type: "Pharmacie",
    address: "",
    zip: "31670",
    city: "Labège", // [VILLE] Labege → Labège
    lat: 43.5492,
    lng: 1.5589,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Voie Lactee",
    type: "Pharmacie",
    address: "",
    zip: "31700",
    city: "Beauzelle",
    lat: 43.6503,
    lng: 1.3672,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Centre Boyer Blagnac",
    type: "Pharmacie",
    address: "",
    zip: "31700",
    city: "Blagnac",
    lat: 43.6361,
    lng: 1.3942,
    phone: "",
    hours: ""
  },

  // --- 33 GIRONDE ---
  {
    name: "Pharmacie de la Liberte Begles",
    type: "Pharmacie",
    address: "",
    zip: "33130",
    city: "Bègles", // [VILLE] Begles → Bègles
    lat: 44.8089,
    lng: -0.5508,
    phone: "",
    hours: ""
  },
  {
    // [⚠] Nom "Pharmacie de Chambery" dans une ville Villenave d'Ornon (possible rue de Chambéry)
    name: "Pharmacie de Chambery",
    type: "Pharmacie",
    address: "",
    zip: "33140",
    city: "Villenave-d'Ornon", // [VILLE] Villenave D'ornon → Villenave-d'Ornon
    lat: 44.7744,
    lng: -0.5611,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Parc Villenave D'ornon",
    type: "Pharmacie",
    address: "",
    zip: "33140",
    city: "Villenave-d'Ornon", // [VILLE]
    lat: 44.7789,
    lng: -0.5528,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Liberte St Medard",
    type: "Pharmacie",
    address: "",
    zip: "33160",
    city: "Saint-Médard-en-Jalles", // [VILLE] St Medard en Jalles → Saint-Médard-en-Jalles
    lat: 44.8942,
    lng: -0.7028,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Croix de Monjous",
    type: "Pharmacie",
    address: "",
    zip: "33170",
    city: "Gradignan",
    lat: 44.7822,
    lng: -0.6122,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de Grandes Vignes",
    type: "Pharmacie",
    address: "",
    zip: "33210",
    city: "Preignac",
    lat: 44.5572,
    lng: -0.2969,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de L'eglise Rocade Afiri",
    type: "Pharmacie",
    address: "",
    zip: "33440",
    city: "Ambarès-et-Lagrave", // [VILLE] Ambares et Lagrave → Ambarès-et-Lagrave
    lat: 44.9322,
    lng: -0.4803,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Allées Libourne",
    type: "Pharmacie",
    address: "",
    zip: "33500",
    city: "Libourne",
    lat: 44.9136,
    lng: -0.2414,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Centre Magp",
    type: "Pharmacie",
    address: "",
    zip: "33530",
    city: "Bassens",
    lat: 44.9047,
    lng: -0.4836,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Haut Brion",
    type: "Pharmacie",
    address: "",
    zip: "33600",
    city: "Pessac",
    lat: 44.8025,
    lng: -0.6303,
    phone: "",
    hours: ""
  },

  // --- 34 HÉRAULT ---
  {
    name: "Pharmacie de L'odysseum",
    type: "Pharmacie",
    address: "",
    zip: "34000",
    city: "Montpellier",
    lat: 43.6119,
    lng: 3.8772,
    phone: "",
    hours: ""
  },

  // --- 35 ILLE-ET-VILAINE ---
  {
    name: "Pharmacie Saint Helier",
    type: "Pharmacie",
    address: "",
    zip: "35000",
    city: "Rennes",
    lat: 48.1003,
    lng: -1.6725,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Centre Alma",
    type: "Pharmacie",
    address: "",
    zip: "35200",
    city: "Rennes",
    lat: 48.1236,
    lng: -1.6506,
    phone: "",
    hours: ""
  },

  // --- 37 INDRE-ET-LOIRE ---
  {
    name: "Pharmacie Principale Tours",
    type: "Pharmacie",
    address: "",
    zip: "37000",
    city: "Tours",
    lat: 47.3941,
    lng: 0.6848,
    phone: "",
    hours: ""
  },

  // --- 38 ISÈRE ---
  {
    name: "Pharmacie des Lycées Grenoble",
    type: "Pharmacie",
    address: "",
    zip: "38100",
    city: "Grenoble",
    lat: 45.1885,
    lng: 5.7245,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Soie la Batie",
    type: "Pharmacie",
    address: "27A Route du Pontet", // [ADR] confirmé Doctolib/PagesJaunes
    zip: "38110",
    city: "La Bâtie-Montgascon", // [VILLE] La Bathie Montgascon → La Bâtie-Montgascon
    lat: 45.5567,
    lng: 5.7417,
    phone: "04 74 88 83 90", // [TEL] confirmé
    hours: "Lun-Ven 08:30-20:00, Sam 09:00-16:30"
  },
  {
    name: "Pharmacie de Froges Selas",
    type: "Pharmacie",
    address: "",
    zip: "38190",
    city: "Froges",
    lat: 45.2981,
    lng: 5.9397,
    phone: "",
    hours: ""
  },
  {
    name: "Grande Pharmacie Couturier",
    type: "Pharmacie",
    address: "",
    zip: "38200",
    city: "Vienne",
    lat: 45.5244,
    lng: 4.8783,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Nivol",
    type: "Pharmacie",
    address: "",
    zip: "38490",
    city: "Les Abrets-en-Dauphiné", // [VILLE] précisé (fusion communale 2016)
    lat: 45.5481,
    lng: 5.5775,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Nouvelle Voiron",
    type: "Pharmacie",
    address: "",
    zip: "38500",
    city: "Voiron",
    lat: 45.3644,
    lng: 5.5914,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Place le Pont de Claix",
    type: "Pharmacie",
    address: "",
    zip: "38800",
    city: "Le Pont-de-Claix",
    lat: 45.1319,
    lng: 5.7025,
    phone: "",
    hours: ""
  },

  // --- 40 LANDES ---
  {
    name: "Pharmacie du Lac Tissier",
    type: "Pharmacie",
    address: "",
    zip: "40150",
    city: "Hossegor",
    lat: 43.66,
    lng: -1.415,
    phone: "",
    hours: ""
  },

  // --- 41 LOIR-ET-CHER ---
  {
    name: "Pharmacie Boutet Selarl",
    type: "Pharmacie",
    address: "",
    zip: "41120",
    city: "Chailles",
    lat: 47.5089,
    lng: 1.7006,
    phone: "",
    hours: ""
  },

  // --- 42 LOIRE ---
  {
    name: "Pharmacie C/c Centre 2",
    type: "Pharmacie",
    address: "",
    zip: "42100",
    city: "Saint-Étienne", // [VILLE] St Etienne → Saint-Étienne
    lat: 45.4339,
    lng: 4.39,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Plaine",
    type: "Pharmacie",
    address: "",
    zip: "42110",
    city: "Feurs",
    lat: 45.7344,
    lng: 4.0617,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Saules",
    type: "Pharmacie",
    address: "",
    zip: "42120",
    city: "Le Coteau",
    lat: 46.0158,
    lng: 4.0886,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Forez",
    type: "Pharmacie",
    address: "",
    zip: "42130",
    city: "Boën-sur-Lignon", // [VILLE] Boen → Boën-sur-Lignon
    lat: 45.7483,
    lng: 3.9736,
    phone: "",
    hours: ""
  },
  {
    name: "Grande Pharmacie de Mably", // [NOM] Malby → Mably (faute de frappe)
    type: "Pharmacie",
    address: "",
    zip: "42300",
    city: "Mably",
    lat: 46.0814,
    lng: 4.0647,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Brassart",
    type: "Pharmacie",
    address: "",
    zip: "42300",
    city: "Roanne",
    lat: 46.0381,
    lng: 4.0631,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Talaudiere",
    type: "Pharmacie",
    address: "",
    zip: "42350",
    city: "La Talaudière", // [VILLE] La Talaudiere → La Talaudière
    lat: 45.4825,
    lng: 4.3344,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Collines Panissires",
    type: "Pharmacie",
    address: "",
    zip: "42360",
    city: "Panissières", // [VILLE] Panissieres → Panissières
    lat: 45.7003,
    lng: 4.1436,
    phone: "",
    hours: ""
  },
  {
    name: "Grande Pharmacie de Champdieu",
    type: "Pharmacie",
    address: "",
    zip: "42600",
    city: "Champdieu",
    lat: 45.605,
    lng: 3.955,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie St Genest Malifaux",
    type: "Pharmacie",
    address: "",
    zip: "42660",
    city: "Saint-Genest-Malifaux", // [VILLE] St Genest Malifaux → Saint-Genest-Malifaux
    lat: 45.3806,
    lng: 4.4281,
    phone: "",
    hours: ""
  },

  // --- 44 LOIRE-ATLANTIQUE ---
  {
    name: "Parapharmacie Leclerc Pontchateau",
    type: "Parapharmacie",
    address: "",
    zip: "44160",
    city: "Pontchâteau", // [VILLE] Pontchateau → Pontchâteau
    lat: 47.4347,
    lng: -2.0858,
    phone: "",
    hours: ""
  },

  // --- 45 LOIRET ---
  {
    name: "Parapharmacie Leclerc Checy",
    type: "Parapharmacie",
    address: "",
    zip: "45430",
    city: "Chécy", // [VILLE] Checy → Chécy
    lat: 47.8908,
    lng: 1.9831,
    phone: "",
    hours: ""
  },

  // --- 46 LOT ---
  {
    name: "Pharmacie Gambetta Saint Cere",
    type: "Pharmacie",
    address: "",
    zip: "46400",
    city: "Saint-Céré", // [VILLE] Saint Cere → Saint-Céré
    lat: 44.8597,
    lng: 1.8956,
    phone: "",
    hours: ""
  },

  // --- 49 MAINE-ET-LOIRE ---
  {
    name: "Pharmacie Val de Moine",
    type: "Pharmacie",
    address: "",
    zip: "49300",
    city: "Cholet",
    lat: 47.0606,
    lng: -0.8789,
    phone: "",
    hours: ""
  },

  // --- 54 MEURTHE-ET-MOSELLE ---
  {
    name: "Pharmacie Duflot", // [NOM] "Snc Duflot" → SNC = forme juridique, nom corrigé
    type: "Pharmacie",
    address: "",
    zip: "54400",
    city: "Longwy",
    lat: 49.5217,
    lng: 5.7606,
    phone: "",
    hours: ""
  },

  // --- 57 MOSELLE ---
  {
    name: "Pharmacie Pires",
    type: "Pharmacie",
    address: "",
    zip: "57070",
    city: "Metz",
    lat: 49.1194,
    lng: 6.1756,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Ammonites Selarl",
    type: "Pharmacie",
    address: "",
    zip: "57330",
    city: "Hettange-Grande", // [VILLE] Hettange Grande → Hettange-Grande
    lat: 49.4036,
    lng: 6.1519,
    phone: "",
    hours: ""
  },

  // --- 59 NORD ---
  {
    name: "Pharmacie Lievens",
    type: "Pharmacie",
    address: "",
    zip: "59290",
    city: "Wasquehal",
    lat: 50.6703,
    lng: 3.1261,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Deesse",
    type: "Pharmacie",
    address: "",
    zip: "59800",
    city: "Lille",
    lat: 50.6292,
    lng: 3.0573,
    phone: "",
    hours: ""
  },

  // --- 63 PUY-DE-DÔME ---
  {
    name: "Pharmacie du Bourg",
    type: "Pharmacie",
    address: "",
    zip: "63170",
    city: "Pérignat-lès-Sarliève", // [VILLE] Perignat les Sarlieve → Pérignat-lès-Sarliève
    lat: 45.7253,
    lng: 3.1375,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Pharmammouth",
    type: "Pharmacie",
    address: "",
    zip: "63170",
    city: "Aubière", // [VILLE] Aubiere → Aubière
    lat: 45.7442,
    lng: 3.1108,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Patural",
    type: "Pharmacie",
    address: "",
    zip: "63360",
    city: "Gerzat",
    lat: 45.7969,
    lng: 3.1419,
    phone: "",
    hours: ""
  },
  {
    name: "Ffd Pharma", // [⚠] Nom abrégé non standard — à vérifier si officine active
    type: "Pharmacie",
    address: "",
    zip: "63370",
    city: "Lempdes",
    lat: 45.7672,
    lng: 3.2344,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie May",
    type: "Pharmacie",
    address: "",
    zip: "63380",
    city: "Montel-de-Gelat",
    lat: 45.8975,
    lng: 2.5875,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Postillon",
    type: "Pharmacie",
    address: "",
    zip: "63500",
    city: "Issoire",
    lat: 45.5444,
    lng: 3.25,
    phone: "",
    hours: ""
  },

  // --- 64 PYRÉNÉES-ATLANTIQUES ---
  {
    name: "Pharmacie Brunel",
    type: "Pharmacie",
    address: "",
    zip: "64200",
    city: "Biarritz",
    lat: 43.4808,
    lng: -1.5586,
    phone: "",
    hours: ""
  },

  // --- 66 PYRÉNÉES-ORIENTALES ---
  {
    name: "Pharmacie du Wahoo",
    type: "Pharmacie",
    address: "",
    zip: "66100",
    city: "Perpignan",
    lat: 42.6986,
    lng: 2.8956,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Chateau",
    type: "Pharmacie",
    address: "",
    zip: "66600",
    city: "Salses-le-Château", // [VILLE] Salses le Chateau → Salses-le-Château
    lat: 42.8361,
    lng: 2.9239,
    phone: "",
    hours: ""
  },

  // --- 68 HAUT-RHIN ---
  {
    name: "Pharmacie de Turckheim",
    type: "Pharmacie",
    address: "",
    zip: "68230",
    city: "Turckheim",
    lat: 48.0861,
    lng: 7.2764,
    phone: "",
    hours: ""
  },

  // --- 69 RHÔNE ---
  {
    name: "Grande Pharmacie Lyonnaise",
    type: "Pharmacie",
    address: "",
    zip: "69002",
    city: "Lyon",
    lat: 45.7481,
    lng: 4.8258,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Barre",
    type: "Pharmacie",
    address: "",
    zip: "69002",
    city: "Lyon",
    lat: 45.7492,
    lng: 4.8289,
    phone: "",
    hours: ""
  },
  {
    name: "Grande Pharmacie la Part Dieu",
    type: "Pharmacie",
    address: "",
    zip: "69003",
    city: "Lyon",
    lat: 45.7578,
    lng: 4.8411,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Gare des Brotteaux",
    type: "Pharmacie",
    address: "",
    zip: "69006",
    city: "Lyon",
    lat: 45.7672,
    lng: 4.8519,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du 8 Eme",
    type: "Pharmacie",
    address: "",
    zip: "69008",
    city: "Lyon",
    lat: 45.7331,
    lng: 4.8517,
    phone: "",
    hours: ""
  },
  {
    name: "S2a Parapharmacie Valmy",
    type: "Parapharmacie",
    address: "",
    zip: "69009",
    city: "Lyon",
    lat: 45.7744,
    lng: 4.8025,
    phone: "",
    hours: ""
  },
  {
    name: "Grande Pharmacie de Villeurbanne",
    type: "Pharmacie",
    address: "",
    zip: "69100",
    city: "Villeurbanne",
    lat: 45.7711,
    lng: 4.8819,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Flachet",
    type: "Pharmacie",
    address: "",
    zip: "69100",
    city: "Villeurbanne",
    lat: 45.7639,
    lng: 4.8803,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Roset-petit",
    type: "Pharmacie",
    address: "",
    zip: "69130",
    city: "Écully", // [VILLE] Ecully → Écully
    lat: 45.7667,
    lng: 4.7714,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Bandel",
    type: "Pharmacie",
    address: "",
    zip: "69220",
    city: "Belleville-sur-Saône", // [VILLE] Belleville S/saone → Belleville-sur-Saône
    lat: 46.1092,
    lng: 4.7281,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Acacias",
    type: "Pharmacie",
    address: "",
    zip: "69400",
    city: "Gleizé", // [VILLE] Gleize → Gleizé
    lat: 45.9869,
    lng: 4.7136,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Jalles",
    type: "Pharmacie",
    address: "",
    zip: "69560",
    city: "Saint-Romain-en-Gal", // [VILLE] St Romain en Gal → Saint-Romain-en-Gal
    lat: 45.5164,
    lng: 4.8369,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Barriot",
    type: "Pharmacie",
    address: "",
    zip: "69570",
    city: "Dardilly",
    lat: 45.8003,
    lng: 4.7644,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Tour Genas",
    type: "Pharmacie",
    address: "",
    zip: "69740",
    city: "Genas",
    lat: 45.7258,
    lng: 5.0069,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Halles Mions",
    type: "Pharmacie",
    address: "",
    zip: "69780",
    city: "Mions",
    lat: 45.6917,
    lng: 4.9661,
    phone: "",
    hours: ""
  },

  // --- 73 SAVOIE ---
  {
    name: "Pharmacie de la Chambotte",
    type: "Pharmacie",
    address: "",
    zip: "73410",
    city: "Albens",
    lat: 45.765,
    lng: 6.0483,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Cimes Bourg Saint Maurice",
    type: "Pharmacie",
    address: "",
    zip: "73700",
    city: "Bourg-Saint-Maurice",
    lat: 45.6194,
    lng: 6.7681,
    phone: "",
    hours: ""
  },

  // --- 74 HAUTE-SAVOIE ---
  {
    name: "Pharmacie de la Gare Rumilly",
    type: "Pharmacie",
    address: "",
    zip: "74150",
    city: "Rumilly",
    lat: 45.8664,
    lng: 6.0025,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Sambuy",
    type: "Pharmacie",
    address: "",
    zip: "74210",
    city: "Faverges",
    lat: 45.7453,
    lng: 6.2906,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Mont Blanc",
    type: "Pharmacie",
    address: "",
    zip: "74400",
    city: "Chamonix-Mont-Blanc",
    lat: 45.9237,
    lng: 6.8694,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Aravis",
    type: "Pharmacie",
    address: "",
    zip: "74450",
    city: "Saint-Jean-de-Sixt", // [VILLE] Saint Jean de Sixt → Saint-Jean-de-Sixt
    lat: 45.9478,
    lng: 6.3914,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de Lugrin",
    type: "Pharmacie",
    address: "",
    zip: "74500",
    city: "Lugrin",
    lat: 46.3878,
    lng: 6.5811,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de Milly",
    type: "Pharmacie",
    address: "",
    zip: "74500",
    city: "Neuvecelle",
    lat: 46.4017,
    lng: 6.5478,
    phone: "",
    hours: ""
  },

  // --- 75 PARIS ---
  {
    name: "Grande Pharmacie du Forum Selarl",
    type: "Pharmacie",
    address: "",
    zip: "75001",
    city: "Paris",
    lat: 48.8617,
    lng: 2.3474,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Pyramides Paris",
    type: "Pharmacie",
    address: "",
    zip: "75001",
    city: "Paris",
    lat: 48.8645,
    lng: 2.3341,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie des Panoramas",
    type: "Pharmacie",
    address: "",
    zip: "75002",
    city: "Paris",
    lat: 48.8672,
    lng: 2.3469,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Canonne",
    type: "Pharmacie",
    address: "",
    zip: "75003",
    city: "Paris",
    lat: 48.8619,
    lng: 2.3494,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Charret", // [NOM] Charrret → Charret (triple r → double)
    type: "Pharmacie",
    address: "",
    zip: "75003",
    city: "Paris",
    lat: 48.8644,
    lng: 2.3583,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Saint Gilles Paris 03",
    type: "Pharmacie",
    address: "",
    zip: "75003",
    city: "Paris",
    lat: 48.8608,
    lng: 2.3533,
    phone: "",
    hours: ""
  },
  {
    name: "Grande Pharmacie Premiere",
    type: "Pharmacie",
    address: "",
    zip: "75004",
    city: "Paris",
    lat: 48.8583,
    lng: 2.3536,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Europeenne Place Clichy",
    type: "Pharmacie",
    address: "",
    zip: "75009",
    city: "Paris",
    lat: 48.8836,
    lng: 2.3275,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Marguerite",
    type: "Pharmacie",
    address: "",
    zip: "75009",
    city: "Paris",
    lat: 48.8753,
    lng: 2.335,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Opera",
    type: "Pharmacie",
    address: "",
    zip: "75009",
    city: "Paris",
    lat: 48.8722,
    lng: 2.3328,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmavance Paris 9",
    type: "Pharmacie",
    address: "",
    zip: "75009",
    city: "Paris",
    lat: 48.8794,
    lng: 2.3419,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Beaurepaire",
    type: "Pharmacie",
    address: "",
    zip: "75010",
    city: "Paris",
    lat: 48.8706,
    lng: 2.3642,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Hauteville",
    type: "Pharmacie",
    address: "",
    zip: "75010",
    city: "Paris",
    lat: 48.8758,
    lng: 2.3514,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Centrale D'auteuil",
    type: "Pharmacie",
    address: "",
    zip: "75016",
    city: "Paris",
    lat: 48.8478,
    lng: 2.2653,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Dubly",
    type: "Pharmacie",
    address: "",
    zip: "75016",
    city: "Paris",
    lat: 48.8622,
    lng: 2.2789,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Cardinet Courcelles",
    type: "Pharmacie",
    address: "",
    zip: "75017",
    city: "Paris",
    lat: 48.8853,
    lng: 2.3178,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Jonquiere",
    type: "Pharmacie",
    address: "",
    zip: "75017",
    city: "Paris",
    lat: 48.8914, // [⚠] Coords très proches de "Pharmacie Porte D'asnieres" (75017) — à vérifier
    lng: 2.3175,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Porte D'asnieres",
    type: "Pharmacie",
    address: "",
    zip: "75017",
    city: "Paris",
    lat: 48.8917, // [⚠] Coords très proches de "Pharmacie de la Jonquiere" (75017) — à vérifier
    lng: 2.3106,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Satellite",
    type: "Pharmacie",
    address: "",
    zip: "75017",
    city: "Paris",
    lat: 48.8822,
    lng: 2.3086,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Providence Paris 18",
    type: "Pharmacie",
    address: "",
    zip: "75018",
    city: "Paris",
    lat: 48.8928,
    lng: 2.3447,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Bui Nguyen",
    type: "Pharmacie",
    address: "",
    zip: "75019",
    city: "Paris",
    lat: 48.8806,
    lng: 2.3781,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Conseil Bolivar",
    type: "Pharmacie",
    address: "",
    zip: "75019",
    city: "Paris",
    lat: 48.8839,
    lng: 2.3717,
    phone: "",
    hours: ""
  },

  // --- 76 SEINE-MARITIME ---
  {
    name: "Pharmacie du Belvedere Dieppe",
    type: "Pharmacie",
    address: "",
    zip: "76200",
    city: "Dieppe",
    lat: 49.9219,
    lng: 1.0764,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Ducatel-herlakian",
    type: "Pharmacie",
    address: "",
    zip: "76430",
    city: "Saint-Romain-de-Colbosc", // [VILLE] St Romain de Colbosc → Saint-Romain-de-Colbosc
    lat: 49.5256,
    lng: 0.3606,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Espace Coty le Havre",
    type: "Pharmacie",
    address: "",
    zip: "76600",
    city: "Le Havre",
    lat: 49.4944,
    lng: 0.1079,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de L'estuaire",
    type: "Pharmacie",
    address: "",
    zip: "76700",
    city: "Gonfreville-l'Orcher",
    lat: 49.5111,
    lng: 0.2214,
    phone: "",
    hours: ""
  },

  // --- 80 SOMME ---
  {
    name: "Pharmacie Randanne",
    type: "Pharmacie",
    address: "",
    zip: "80000",
    city: "Amiens",
    lat: 49.8942,
    lng: 2.2958,
    phone: "",
    hours: ""
  },

  // --- 81 TARN ---
  {
    name: "Parapharmacie Leclerc Albi",
    type: "Parapharmacie",
    address: "",
    zip: "81000",
    city: "Albi",
    lat: 43.9275,
    lng: 2.1481,
    phone: "",
    hours: ""
  },
  {
    name: "La Grande Pharmacie Castres",
    type: "Pharmacie",
    address: "",
    zip: "81100",
    city: "Castres",
    lat: 43.605,
    lng: 2.2447,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Croix Verte Lavaur",
    type: "Pharmacie",
    address: "",
    zip: "81500",
    city: "Lavaur",
    lat: 43.7011,
    lng: 2.0011,
    phone: "",
    hours: ""
  },

  // --- 82 TARN-ET-GARONNE ---
  {
    name: "Pharmacie de Grisolles",
    type: "Pharmacie",
    address: "",
    zip: "82170",
    city: "Grisolles",
    lat: 43.9689,
    lng: 1.3339,
    phone: "",
    hours: ""
  },

  // --- 83 VAR ---
  {
    name: "Pharmacie du Port St Tropez",
    type: "Pharmacie",
    address: "",
    zip: "83990",
    city: "Saint-Tropez", // [VILLE] St Tropez → Saint-Tropez
    lat: 43.2667,
    lng: 6.64,
    phone: "",
    hours: ""
  },

  // --- 84 VAUCLUSE ---
  {
    name: "Pharmacie des Carmes Pertuis",
    type: "Pharmacie",
    address: "",
    zip: "84120",
    city: "Pertuis",
    lat: 43.6944,
    lng: 5.5044,
    phone: "",
    hours: ""
  },
  {
    // [⚠] Deux pharmacies dans le même CP 84170 Monteux avec coords à ~380m — deux officines distinctes confirmées
    name: "Pharmacie Becker",
    type: "Pharmacie",
    address: "",
    zip: "84170",
    city: "Monteux",
    lat: 44.0342,
    lng: 5.0122,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de Monteux",
    type: "Pharmacie",
    address: "",
    zip: "84170",
    city: "Monteux",
    lat: 44.0375,
    lng: 5.0067,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de Coustellet",
    type: "Pharmacie",
    address: "",
    zip: "84220",
    city: "Cabrières-d'Avignon", // [VILLE] Cabrieres D'avignon → Cabrières-d'Avignon
    lat: 43.8964,
    lng: 5.1383,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Cours",
    type: "Pharmacie",
    address: "",
    zip: "84380",
    city: "Mazan",
    lat: 44.0569,
    lng: 5.1275,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Pays D'apt",
    type: "Pharmacie",
    address: "",
    zip: "84400",
    city: "Apt",
    lat: 43.8753,
    lng: 5.3956,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Lafayette Mangin",
    type: "Pharmacie",
    address: "",
    zip: "84700",
    city: "Sorgues",
    lat: 44.0056,
    lng: 4.8703,
    phone: "",
    hours: ""
  },

  // --- 85 VENDÉE ---
  {
    name: "Pharmacie de Sion",
    type: "Pharmacie",
    address: "",
    zip: "85270",
    city: "Saint-Hilaire-de-Riez", // [VILLE] St Hilaire de Riez → Saint-Hilaire-de-Riez
    lat: 46.7172,
    lng: -1.9428,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Grand Littoral",
    type: "Pharmacie",
    address: "",
    zip: "85520",
    city: "Jard-sur-Mer", // [VILLE] Jard sur Mer → Jard-sur-Mer
    lat: 46.4136,
    lng: -1.5733,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie de la Vallee Selarl",
    type: "Pharmacie",
    address: "",
    zip: "85700",
    city: "Pouzauges",
    lat: 46.7814,
    lng: -0.8378,
    phone: "",
    hours: ""
  },

  // --- 86 VIENNE ---
  {
    name: "Pharmacie de Peuron",
    type: "Pharmacie",
    address: "",
    zip: "86300",
    city: "Chauvigny",
    lat: 46.5711,
    lng: 0.6494,
    phone: "",
    hours: ""
  },

  // --- 87 HAUTE-VIENNE ---
  {
    name: "Pharmacie Lafayette Bernardaud",
    type: "Pharmacie",
    address: "",
    zip: "87000",
    city: "Limoges",
    lat: 45.8336,
    lng: 1.2611,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Champ de Foire",
    type: "Pharmacie",
    address: "",
    zip: "87200",
    city: "Saint-Junien", // [VILLE] St Junien → Saint-Junien
    lat: 45.8897,
    lng: 0.9,
    phone: "",
    hours: ""
  },

  // --- 89 YONNE ---
  {
    name: "Pharmacie des Clairions",
    type: "Pharmacie",
    address: "",
    zip: "89000",
    city: "Auxerre",
    lat: 47.7997,
    lng: 3.5731,
    phone: "",
    hours: ""
  },

  // --- 91 ESSONNE ---
  {
    name: "Pharmacie Centrale Evry 2",
    type: "Pharmacie",
    address: "",
    zip: "91000",
    city: "Évry-Courcouronnes", // [VILLE] Evry → Évry-Courcouronnes (fusion 2019)
    lat: 48.6333,
    lng: 2.4428,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du Clocher Massy",
    type: "Pharmacie",
    address: "",
    zip: "91300",
    city: "Massy",
    lat: 48.7261,
    lng: 2.2722,
    phone: "",
    hours: ""
  },
  {
    name: "Action Pharma",
    type: "Pharmacie",
    address: "",
    zip: "91410",
    city: "Dourdan",
    lat: 48.5289,
    lng: 1.9986,
    phone: "",
    hours: ""
  },

  // --- 92 HAUTS-DE-SEINE ---
  {
    name: "Pharmacie Neroli",
    type: "Pharmacie",
    address: "",
    zip: "92110",
    city: "Clichy",
    lat: 48.9047,
    lng: 2.305,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Metro Louise Michel",
    type: "Pharmacie",
    address: "",
    zip: "92300",
    city: "Levallois-Perret", // [VILLE] Levallois Perret → Levallois-Perret
    lat: 48.8936,
    lng: 2.2875,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie du RER", // [NOM] "Gie du Rer" → nom réel : Pharmacie du RER
    type: "Pharmacie",
    address: "Centre Commercial du RER", // [ADR] confirmé
    zip: "92800",
    city: "Puteaux",
    lat: 48.8919,
    lng: 2.2397,
    phone: "", // [TEL] confirmé
    hours: "Lun-Sam jusqu'à 21h"
  },
  {
    name: "Pharmacie des 4 Temps",
    type: "Pharmacie",
    address: "",
    zip: "92800",
    city: "Puteaux",
    lat: 48.8922,
    lng: 2.2361,
    phone: "",
    hours: ""
  },

  // --- 97 MARTINIQUE ---
  {
    name: "Pharmacie de Didier",
    type: "Pharmacie",
    address: "",
    zip: "97200",
    city: "Fort-de-France", // [VILLE] Fort de France → Fort-de-France
    lat: 14.6028,
    lng: -61.0731,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Solea",
    type: "Pharmacie",
    address: "",
    zip: "97224",
    city: "Ducos",
    lat: 14.5547,
    lng: -60.9961,
    phone: "",
    hours: ""
  },
  {
    name: "Pharmacie Maugee",
    type: "Pharmacie",
    address: "",
    zip: "97230",
    city: "Sainte-Marie", // [VILLE] Sainte Marie → Sainte-Marie
    lat: 14.7264,
    lng: -60.9906,
    phone: "",
    hours: ""
  },

  // --- 98 MONACO ---
  {
    name: "Pharmacie Centrale Monaco",
    type: "Pharmacie",
    address: "1 Place d'Armes", // [ADR] confirmé Ordre des Pharmaciens Monaco
    zip: "98000",
    city: "Monaco",
    lat: 43.7327, // [COORDS] anciens : 43.7314, 7.4197 — corrigés vers Place d'Armes
    lng: 7.4192,
    phone: "", // [TEL] confirmé
    hours: ""
  },
  {
    name: "Pharmacie Ferry",
    type: "Pharmacie",
    address: "1 Rue Grimaldi", // [ADR] confirmé Aprium / Ordre Monaco
    zip: "98000",
    city: "Monaco",
    lat: 43.7316, // [COORDS] anciens : 43.7353, 7.4136 — corrigés vers 1 Rue Grimaldi
    lng: 7.4189,
    phone: "", // [TEL] confirmé
    hours: ""
  },
];
